module.exports = __webpack_public_path__ + "static/media/Tropical TinctureReducedSize-25percent.519d7d0d.svg";